import type { ListGroupOption } from '@athena-lib/ListGroupSelectable';
import type { Attributes, AttributeValueSingle } from '@stickerapp-org/nomisma';
import type { ProductItemInterface } from './product/model/ProductItemInterface';
import type { PriceAndQuantityOptionInterface } from './model/PriceAndQuantityOptionInterface';

export type ProductAndPrices = {
  item: ProductItemInterface;
  price: PriceAndQuantityOption;
  price_list: PriceAndQuantityOption;
};

export type WizardStates = {
  canUpload: boolean;
  customSizeOpen: boolean;
  customQuantityOpen: boolean;
  price: PriceAndQuantityOptionInterface;
  customQuantityInvalid: boolean;
  uploadProgressPercentage: number;
  selectedLaminate: AttributeValueSingle;
  showVat: boolean;
  shapeList: ListGroupOption[];
  materialList: ListGroupOption[];
  laminateList: ListGroupOption[];
  sizeList: ListGroupOption[];
  pricesAndQuantity: ListGroupOption[];
  selectedQuantity: string | number | undefined;
  productName: string;
  productItem: string;
};

export type StickerWizardProductData = {
  productItem: ProductItemInterface;
  attributes: Attributes;
  pricesAndQuantity: Array<PriceAndQuantityOption>;
  productAndPricesInterface: ProductAndPrices;
  materialPreset?: string;
  price: PriceAndQuantityOption;
  file?: FileAppData;
};

export type ProductList =
  | ''
  | 'die_cut'
  | 'sheet'
  | 'sheet_legacy'
  | 'sheet_kiss_cut'
  | 'hang_tag'
  | '3d_dome'
  | 'front_adhesive'
  | 'heavy_duty'
  | 'removable'
  | 'wall'
  | 'floor'
  | 'double_sided'
  | 'labels_on_sheet'
  | 'campaign_holo_7'
  | 'labels_on_roll'
  | 'single_on_sheet'
  | 'heat_transfer_singles'
  | 'transfer_sticker';

export type StickerWizardData = {
  productWizardData: StickerWizardProductData;
  productList: ProductList[];
  fileappUrl: string;
  baseApiUrl: string;
  translations: TranslationInterface;
  includeVat: boolean;
  materialPreset?: string;
  materialPresetOnly?: boolean;
  outOfStockProducts?: Array<string>;
  laminatePreset?: string;
  specs?: Array<{ label: string }>;
};

export type TranslationInterface = {
  lang: string;
  strings: TranslationPairs;
};

export type PriceAndQuantityOption = {
  price: string;
  quantity: number;
  quantityFormatted: string;
  save: number;
  totalFormatted: string;
  total: number;
  unitPriceFormatted?: string;
};

export type FileAppData = {
  fileapp_id: string;
  fileapp_region: string;
  height: number;
  name: string;
  size: number;
  thumb_url: string;
  upload_id: number;
  width: number;
  background: string;
};

export type TranslationPairs = Record<string, string>;

export enum StickerWizardProductsEnum {
  DIE_CUT = 'die_cut',
  SHEET = 'sheet',
  // SHEET_LEGACY = 'sheet_legacy',
  SHEET_KISS_CUT = 'sheet_kiss_cut',
  HANG_TAG = 'hang_tag',
  DOME = '3d_dome',
  FRONT_ADHESIVE = 'front_adhesive',
  HEAVY_DUTY = 'heavy_duty',
  REMOVABLE = 'removable',
  WALL = 'wall',
  FLOOR = 'floor',
  DOUBLE_SIDED = 'double_sided',
  LABELS_ON_SHEET = 'labels_on_sheet',
  LABELS_ON_ROLL = 'labels_on_roll',
  SINGLE_ON_SHEET = 'single_on_sheet',
}

export type CustomValues = {
  customSize: boolean;
  customQuantity: boolean;
  uploadEvent?: string;
};

export type Materials = Array<string> | undefined;

export type SizeTypes = 'both' | 'list' | 'custom';

export type Orders =
  | Array<'product' | 'shape' | 'material' | 'laminate' | 'size' | 'quantity' | 'foil'>
  | undefined;
